<template>
  <div>
    <div tabindex="0" ref="modal" class="modal-mask">  </div>

    <rare-modal-close-icon-large
      class="rareModalCloseIcon show-for-medium"
      @clicked="closeModal"
    />

    <rare-modal-close-icon-medium
      class="rareModalCloseIcon show-for-small-only"
      @clicked="closeModal"
    />

    <div class="modal-wrapper">
      <div class="modal-container">

        <div class="modal-header text-center">
          <div class="grid-container full">
            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15">
                <h1>{{ title }}</h1>

                <div class="dash"
                     :class="{ newsDash: category === 'News',
                awardsDash: category === 'Awards',
                pressDash: category === 'Press',}">&nbsp;</div>

                <p><strong>{{ category }}</strong> {{ newsDate }}</p>
                <img :src="imageLink" class="newsHeaderImage" />
              </div>
            </div>
          </div>
        </div>

        <div class="modal-body">
          <div class="grid-container full">
            <div class="grid-x">
              <div class="small-12 cell page-contents-15">

                <p class="tag"><strong v-html="tag"></strong></p>

                <p v-html="content"></p>

              </div>
              <div class="hide-for-small-only medium-6 cell">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLargeBlack';
import RareModalCloseIconMedium from 'rare-patternlab/icons/navigation/RareModalCloseIconMediumBlack';


export default {
  name: 'RareNewsNewsItemModal',
  components: {
    'rare-apply-now-button': RareStandardButton,
    'rare-modal-close-icon-medium': RareModalCloseIconMedium,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
  },
  data() {
    return {
      title: '',
      category: '',
      newsDate: '',
      tag: '',
      content: '',
      imageLink: null,
      backTo: '',
      apiURL: 'https://use47ihl4fb6wuhpzo5vixf3740yapti.lambda-url.eu-west-1.on.aws/?article=',
    };
  },

  methods: {
    closeModal() {
      this.$router.go(-1);
      this.$router.push('/news');
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  created() {
    document.addEventListener('keyup', this.watchForEsc);
    this.article = this.$route.params.article;
  },
  mounted() {
    this.$refs.modal.focus();

    this.backTo = this.$store.getters.backTo;

    const requestURL = `${this.apiURL}${this.article}`;

    axios.get(requestURL).then((response) => {
      if (response.status === 200) {
        const articleData = response.data;

        this.title = articleData.news_title;
        this.category = articleData.news_type;
        this.newsDate = articleData.news_date;
        this.tag = articleData.news_tag;
        this.content = articleData.news_content;
        // eslint-disable-next-line
        this.imageLink = require(`@/assets/img/news/main/${articleData.news_img}`);
        this.category = articleData.news_type[0].toUpperCase() + articleData.news_type.slice(1);
      }
    });
  },
  destroyed() {
    document.removeEventListener('keyup', this.watchForEsc);
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .modal-mask {
    position: fixed;
    z-index: 9990;
    top: 0;
    left: 0;
    width: 100%;
    height: 200%;
    display: table;
    transition: opacity .3s ease;
    background-color: rgba(255,255,255, 1);
    overflow: scroll;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9991;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 0;
    background-color: transparent;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    opacity: 1;
  }

  .modal-body {
    margin: 0;
  }

  .modal-default-button {
    float: right;
  }

  .galleryCont {
    margin-top: 40px;
  }

  .galleryImg {
    max-width: 100%;
    margin-bottom: 40px;
  }


  h1 {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  p strong {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }


  .newsDash {
    background-color: $news;
  }
  .awardsDash {
    background-color: $awards;
  }
  .pressDash {
    background-color: $press;
  }

  @media only screen and (max-width: 640px)  {

    .galleryCont {
      margin-top: 40px;
    }

    .galleryImg {
      max-width: 100%;
      margin-bottom: 40px;
    }

    .page-contents-15 {
      padding-left: 7% !important;
      padding-right: 7% !important;
    }

    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 22px;
      z-index: 9995;
    }

    .newsHeaderImage {
      margin: 15px 0 25px 0;
    }

    h1 {
      font-size: 32px;
      line-height: 1.4;
      letter-spacing: 0.4px;
      margin: 75px 0 0 0;
    }

    p {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.71;
      letter-spacing: 0.2px;
    }

    p strong {
      font-size: 18px;
      line-height: 1.78;
      letter-spacing: 0.2px;
    }

    .tag {
      margin-bottom: 10px;
    }

    .dash {
      display: inline-block;
      width: 40px;
      height: 4px;
      padding: 0;
      margin: 0 0 10px 0;
      line-height: 4px;
    }

  }

  @media only screen and (min-width: 641px)  {

    .galleryCont {
      margin-top: 40px;
    }

    .galleryImg {
      max-width: 100%;
      margin-bottom: 40px;
    }

    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 124px;
      top: 96px;
      z-index: 9995;
    }

    .newsHeaderImage {
      margin: 14px 0 50px 0;
    }

    h1 {
      font-size: 56px;
      line-height: 1.29;
      letter-spacing: 0.8px;
      margin: 100px 0 33px 0;
    }

    p {
      font-size: 21px;
      line-height: 1.52;
      letter-spacing: 0.4px;
    }

    p strong {
      font-size: 24px;
      line-height: 1.5;
      letter-spacing: 0.5px;
    }

    .tag {
      margin-bottom: 30px;
    }

    .dash {
      display: inline-block;
      width: 80px;
      height: 8;
      padding: 0;
      margin: 0 0 24px 0;
      line-height: 8px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/news/newsSingle.vue